import { Button } from "ui/button/button";
import { mergeSx } from "ui/merge-sx";

import { MENU_BUTTON_SX } from "ui/actions-menu/actions-menu.styles";

import { type ActionsMenuButtonProps } from "ui/actions-menu/actions-menu.types";

import Icons from "assets";

/**
 * `ActionsMenu` clones its trigger with an `Actions for {itemName}` `aria-label`, which would replace the
 * visible text as the accessible name (WCAG 2.5.3 Label in Name). Clearing it after the spread lets the
 * label name the button; the icon-only triggers keep the injected one.
 */
export const ActionsMenuButton = ({ sx, ...rest }: ActionsMenuButtonProps) => (
  <Button
    endIcon={<Icons.ChevronDown />}
    sx={mergeSx(MENU_BUTTON_SX, sx)}
    {...rest}
    aria-label={undefined}
  />
);
